export const MIN_PER_HOUR = 60;
export const SEC_PER_MIN = 60;
export const NO_VALUE = '--';
export const PSIG_TO_INHG_FACTOR = 2.03602;

export const SUPPORTED_UNITS = {
  // Booleans
  ON_OFF: 'on-off',
  OPEN_CLOSED: 'open-closed',
  BOOLEAN: 'boolean',

  // Temperature
  DEGREES_C: '°c',
  C: 'c', // alias for °c
  CELSIUS: 'celsius', // alias for °c
  DEGREES_F: '°f',
  F: 'f', // alias for °f
  FAHRENHEIT: 'fahrenheit', // alias for °f
  DEGREES_K: '°k',
  K: 'k', // alias for °k
  KELVIN: 'kelvin', // alias for °k

  // Time
  HRS: 'hrs',
  MIN: 'min',
  SEC: 'sec',
  DURATION: 'duration',
  TIMER: 'timer',

  // Frequency
  HZ: 'hz',
  KHZ: 'khz',
  MHZ: 'mhz',
  GHZ: 'ghz',

  // Electrical
  A: 'a',
  AMPS: 'amps',
  KVA: 'kva',
  KVAH: 'kvah',
  KVAR: 'kvar',
  KVARH: 'kvarh',
  KW: 'kw',
  KWH: 'kwh',
  V: 'v',
  VDC: 'vdc',

  // Pressure
  INHG: 'inhg',
  PSI: 'psi',
  PSIA: 'psia',
  PSIG: 'psig',

  // Percentage
  PERCENT_SYMBOL: '%',
  PERCENT: 'percent', // alias for %
  PERCENTAGE: 'percentage', // alias for %

  // Refrigeration
  KW_PER_TR: 'kw/tr',
  TR: 'tr',

  // Other
  $: '$',
  $_PER_KWH: '$/kwh',
  PER_KWH: '/kwh',
  NONE: 'none',
  NUMBER: 'number',
  PID: 'pid',
  PPM: 'ppm',
  RPM: 'rpm',
  STRING: 'string',
} as const;
